import React from "react";

import { SingleSelect, Textfield, PrimaryButton, SecondaryButton } from "widgets";
import {
  SEARCH_BRANCH_BY_CODE,
  SEARCH_BRANCH_BY_NAME,
  MIN_BRANCH_NAME_SEARCH_LENGTH,
  SEARCH_VALIDATION_MESSAGES,
} from "constants/constants";

import styles from "./SearchBranch.module.scss";

const searchBranchByOptions = [
    { key: "code", value: "code", label: "Code" },
    { key: "name", value: "name", label: "Name" },
];

const getSearchBlankError = (value) => {
    const rawValue = String(value || "");
    if (!rawValue) return null;
    if (!rawValue.trim()) {
        return SEARCH_VALIDATION_MESSAGES.SEARCH_VALUE_BLANK;
    }
    return null;
};

const getBranchNameError = (branchName) => {
    const blankError = getSearchBlankError(branchName);
    if (blankError) return blankError;
    const rawValue = String(branchName || "");
    const trimmedValue = rawValue.trim();
    if (trimmedValue && trimmedValue.length < MIN_BRANCH_NAME_SEARCH_LENGTH) {
        return `Branch name must be at least ${MIN_BRANCH_NAME_SEARCH_LENGTH} characters`;
    }
    return null;
};

const handleBranchCodeChange = (e, setBranchCode) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
        setBranchCode(value);
    }
};

const handleChangeTenantCode = (e, setTenantCode, reset, isError) => {
    const value = e.target.value;
    if (/^[a-zA-Z0-9]*$/.test(value)) {
        setTenantCode(value);
        if (isError) reset();
    }
};

const isSearchButtonDisabled = (searchBranchBy, tenantCode, branchCode, branchName) => {
    if (searchBranchBy === SEARCH_BRANCH_BY_CODE) {
        return !tenantCode.trim() || !branchCode.trim();
    }
    if (searchBranchBy === SEARCH_BRANCH_BY_NAME) {
        const trimmedValue = branchName.trim();
        if (!trimmedValue) {
            return true;
        }
        return trimmedValue.length < MIN_BRANCH_NAME_SEARCH_LENGTH;
    }
    return true;
};

const SearchBranch = (props) => {
    const {
        searchBranchBy,
        setSearchBranchBy,
        tenantCode,
        setTenantCode,
        branchCode,
        setBranchCode,
        branchName,
        setBranchName,
        handleOnClickSearchButton,
        isLoading,
        handleOnClickClearButton,
        reset,
        isError,
    } = props;
    const tenantCodeError = getSearchBlankError(tenantCode);
    const branchCodeError = getSearchBlankError(branchCode);
    const branchNameError = getBranchNameError(branchName);

    const handleSearchByChange = (event) => {
        setSearchBranchBy(event.target.value);
        setTenantCode("");
        setBranchCode("");
        setBranchName("");
    };

    return (
        <div className={styles.searchTypeContainer}>
            <div className={styles.searchByField}>
                <SingleSelect
                    tag="Search By"
                    menuItems={searchBranchByOptions}
                    value={searchBranchBy}
                    handleChange={handleSearchByChange}
                />
            </div>
            {searchBranchBy === SEARCH_BRANCH_BY_CODE ? (
                <>
                    <div className={styles.searchTermField}>
                        <Textfield
                            label="Enter tenant code"
                            value={tenantCode}
                        handleOnChange={(e) => handleChangeTenantCode(e, setTenantCode, reset, isError)}
                            error={Boolean(tenantCodeError)}
                            helperText={tenantCodeError}
                        />
                    </div>
                    <div className={styles.searchTermField}>
                        <Textfield
                            label="Enter branch code"
                            value={branchCode}
                            handleOnChange={(e) => handleBranchCodeChange(e, setBranchCode)}
                            error={Boolean(branchCodeError)}
                            helperText={branchCodeError}
                        />
                    </div>
                </>
            ) : (
                <div className={styles.searchTermField}>
                    <Textfield
                        label="Enter branch name"
                        value={branchName}
                        handleOnChange={(e) => setBranchName(e.target.value)}
                        error={Boolean(branchNameError)}
                        helperText={branchNameError}
                    />
                </div>
            )}
            <div className={styles.searchActions}>
                <PrimaryButton
                    onClick={handleOnClickSearchButton}
                disabled={isSearchButtonDisabled(searchBranchBy, tenantCode, branchCode, branchName) || isLoading}
                >
                    {isLoading ? "Searching..." : "Search"}
                </PrimaryButton>
                <SecondaryButton onClick={handleOnClickClearButton}>Clear</SecondaryButton>
            </div>
        </div>
    );
}
export default SearchBranch;
